<template>
  <v-dialog
    v-model="show"
    scrollable
    max-width="710"
    transition="dialog-bottom-transition"
    content-class="inquiry-dialog"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        depressed
        small
        class="rounded-lg"
        color="primary"
      >
        Ver
      </v-btn>
    </template>

    <v-card
      style="width: 660px;"
      flat
      class="rounded-l-0 fill-height rounded-lg grow ml-auto d-flex flex-column"
    >
      <v-card-title>
        Observaciones de la propiedad
      </v-card-title>
      <v-card-text
        style="flex-grow: 1; overflow: auto; scrollbar-gutter: stable; gap: 12px"
        class="d-flex flex-column"
      >
        <div v-for="observation in observations">
          <observation
            @reload="$emit('reload')"
            :observation="observation"
          ></observation>
        </div>
      </v-card-text>

      <v-card-actions class="px-6 pb-4">
        <v-textarea
          v-model="newObservation"
          outlined
          rows="3"
          placeholder="Escriba una observación aquí..."
          class="rounded-lg"
          append-icon="mdi-send"
          @click:append="create"
          @keyup.enter="create"
          hide-details
        ></v-textarea>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { CreateObservation } from "@/graphql/mutations/properties";
import Observation from "./Observation";

export default {
  data: () => ({
    show: false,
    newObservation: null
  }),

  props: {
    observations: {
      required: false,
      type: Array,
      default: () => {
        return [];
      }
    },
    propertyId: {
      required: false,
      type: [String, Number],
      default: null
    }
  },

  computed: {
    ...mapGetters(["currentUser"])
  },

  methods: {
    create() {
      this.$apollo
        .mutate({
          mutation: CreateObservation,
          variables: {
            input: {
              attributes: {
                message: this.newObservation,
                propertyId: this.propertyId || this.$route.params.id
              }
            }
          }
        })
        .then(res => {
          this.newObservation = null;
          this.$emit("reload");
        });
    }
  },

  components: {
    Observation
  }
};
</script>
